
const getOS = ():"WIN"|"ANDROID"|"IOS"|"UNKNOWN" => {
  // Inside the app the cordova device plugin knows the platform for certain
  // (only set once "deviceready" has fired)
  const devicePlatform = (globalThis as any).device?.platform;
  if (typeof devicePlatform === "string") {
    const normalizedPlatform = devicePlatform.toLowerCase();

    if (normalizedPlatform.indexOf("ios") >= 0 || normalizedPlatform.indexOf("iphone") >= 0 || normalizedPlatform.indexOf("ipad") >= 0) {
      return "IOS";
    }

    if (normalizedPlatform.indexOf("android") >= 0) {
      return "ANDROID";
    }
  }

  const userAgent = navigator.userAgent || navigator.vendor ;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
      return "WIN";
  }

  if (/android/i.test(userAgent)) {
      return "ANDROID";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "IOS";
  }

  // iPadOS 13+ reports a desktop Mac user agent, but real Macs have no touch screen
  if (/Macintosh|Mac OS X/i.test(userAgent) && navigator.maxTouchPoints > 1) {
      return "IOS";
  }

  return "UNKNOWN";
}

type AppTokenPlatform = "ios"|"android";

const getAppTokenPlatform = (): AppTokenPlatform | undefined => {
  const os = getOS();
  if (os === "IOS") return "ios";
  if (os === "ANDROID") return "android";

  return undefined;
}

interface IBrowserInfo {
  name: string;
  version: string;
  mobile?: boolean;
  platform?: string;
};

interface IUADataBrand { brand: string; version: string };

interface IUAData {
  brands?: IUADataBrand[];
  mobile?: boolean;
  platform?: string;
};

function detectBrowser(): IBrowserInfo {
  // 1) Prefer User-Agent Client Hints (Chromium-based)
  const uaData = (navigator as any).userAgentData as IUAData | undefined;

  if (uaData?.brands?.length) {
    // Pick the most meaningful brand (avoid "Not A(Brand)")
    const preferred =
      uaData.brands.find((b) => !/not/i.test(b.brand)) ?? uaData.brands[0];

    return {
      name: preferred.brand,
      version: preferred.version,
      mobile: uaData.mobile,
      platform: uaData.platform,
    };
  }

  // 2) Fallback: parse userAgent
  const ua = navigator.userAgent;

  // Order matters
  const rules: Array<{ name: string; regex: RegExp }> = [
    { name: "Microsoft Edge", regex: /Edg\/([\d.]+)/ },
    { name: "Opera", regex: /OPR\/([\d.]+)/ },
    { name: "Chrome (iOS)", regex: /CriOS\/([\d.]+)/ },
    { name: "Firefox (iOS)", regex: /FxiOS\/([\d.]+)/ },
    { name: "Chrome", regex: /Chrome\/([\d.]+)/ },
    { name: "Firefox", regex: /Firefox\/([\d.]+)/ },
    { name: "Safari", regex: /Version\/([\d.]+).*Safari/ },
  ];

  for (const rule of rules) {
    const m = ua.match(rule.regex);
    if (m) return { name: rule.name, version: m[1] };
  }

  return { name: "Unknown", version: "Unknown" };
}

export { getOS, getAppTokenPlatform, detectBrowser };



// WEBPACK FOOTER //
// ./src/helpers/osDetection.ts